import { render } from "./signature_step.vue?vue&type=template&id=4b2500b0&scoped=true"
import script from "./signature_step.vue?vue&type=script&lang=js"
export * from "./signature_step.vue?vue&type=script&lang=js"

import "./signature_step.vue?vue&type=style&index=0&id=4b2500b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b2500b0"]])

export default __exports__